import { render } from "./BlockFace.vue?vue&type=template&id=77f1f5e4"
import script from "./BlockFace.vue?vue&type=script&lang=js"
export * from "./BlockFace.vue?vue&type=script&lang=js"

import "./BlockFace.vue?vue&type=style&index=0&id=77f1f5e4&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__